import { imagePrefix } from '@/constants';
import { IBbs } from '@/models/types/bbs';
import { wonderfulList } from '@/services/api';
import moment from 'moment';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { DetailCard, MTools, Tabs } from '..';
import styles from './index.less';

interface IDetailActivityProps {
  id?: string;
}

interface IItem {
  title: string;
  list: IBbs[]
}
const DetailActivity: React.FC<IDetailActivityProps> = ({ id }) => {
  const [tabKey, setTabKey] = useState<number>(0);
  const [list, setList] = useState<IItem[]>([])

  useEffect(() => {
    getList()
  }, [])

  const getList = async () => {
    const result = await wonderfulList()
    if (result.success) {
      setList(result.data)
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }
  const renderContent = () => {
    const currentList = list[tabKey]
    if (!currentList) return null
    return (
      <div className={styles.list}>
        {list[tabKey].list?.map(item => {
          return (
            <div
              className={styles.item}
              key={item.id}
              onClick={() => {
                if (id !== item.id) {
                  MTools.Url.gotoUrl(`/app/forum/detail/${item.id}`)
                } else {
                  window.scrollTo(0, 0)
                }
              }}
            >
              <DetailCard item={{
                title: item.title,
                cover: item.cover,
                vipId: getTime(item.startTime, item.endTime, tabKey === 1) || ''
              }}></DetailCard>
            </div>
          )
        })}
      </div>
    )
  }

  const onDictChange = (val: string) => {
    const nextTabKey = +val
    if (nextTabKey <= 1) {
      setTabKey(nextTabKey)
    } else if (nextTabKey == 2) {
      //网络安全教育云课堂
      MTools.Url.gotoUrl('/app/topic/1');
    } else {
      //跳转微课展播
      MTools.Url.gotoUrl('/app/topic/2');
    }
  }

  const getTime = (startTime: string, endTime: string, isTheme = false) => {
    if (!startTime || !endTime) return
    if (isTheme) {
      return `${moment(startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日')} 晚上`
    }
    return `${moment(startTime, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日 HH:mm')}`//-${moment(endTime, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')}`
  }

  return (
    <div className={styles.index}>
      <div className={styles.title}>
        <img src={imagePrefix('title-logo.png')} alt="" />
        精彩活动
      </div>
      <div className={styles.tabs}>
        <Tabs
          showAll={false}
          defaultKey={'' + tabKey}
          data={[{
            name: '网络安全技术高峰论坛',
            value: '0',
          }, {
            name: '网络安全线上主题晚会',
            value: '1',
          }, {
            name: '网络安全教育云课堂',
            value: '2',
          }, {
            name: '微课展播',
            value: '3',
          }]}
          onDictChange={onDictChange}></Tabs>
      </div>
      <div>
        {renderContent()}
      </div>
    </div>
  );
};

export default DetailActivity;